import { noop } from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { MenuItem } from 'react-bootstrap';

import withId from '../../decorators/withId';

const ActionMenuItem = ({
  id,
  actionId,
  children,
  onSelect,
  disabled,
}) => (
  <MenuItem
    id={id}
    eventKey={actionId}
    onSelect={onSelect}
    disabled={disabled}
  >
    {children}
  </MenuItem>
);

ActionMenuItem.propTypes = {
  /** Id of menu action item. it will be passed to _onSelect_ handler */
  actionId: PropTypes.string,
  /** Content shown in action menu item */
  children: PropTypes.any,
  /** Gets called when user selects action item */
  onSelect: PropTypes.func,
  /** Passed to data-id prop on button component
   *  @ignore
   */
  id: PropTypes.string,
  disabled: PropTypes.bool,
};

ActionMenuItem.defaultProps = {
  actionId: null,
  children: null,
  onSelect: noop,
  id: null,
  disabled: false,
};

export { ActionMenuItem };

export default withId('Item', ['id', 'actionId'])(ActionMenuItem);
